export default __webpack_public_path__ + "images/16b166da0f22a7ad532ae00333d62db2.svg";